const global = window

inputs.alias.dataPicker = 'filePicker'
inputs.alias.docPicker = 'filePicker'
inputs.alias.iconPicker = 'filePicker'
inputs.alias.imagePicker = 'filePicker'

inputs.types.filePicker = function (data, name, niceName, type, input, parent, inputWindow) {
    const fieldPreview = parent.find('.input__preview')
    const fieldName = parent.find('.input__label')
    const fieldRemove = parent.find('.input__remove')


    console.log(data);

    input.next().click(function () {
        if (data.type == 'dataPicker') window[input.data('fn')](input, 0)
        else if (data.type == 'docPicker') {
            popupDocPicker(input, 1, data.folder)
        } else if (data.type == 'iconPicker') popupIconPicker(input, 0)
        else popupImagePicker(input, 1, data.album)
    })

    input
        .parent()
        .after(
            '<input name="'
                    + input.attr('name')
                    + '-type" value="'
                    + data.type
                    + '" type="hidden" />',
        )
    input
        .parent()
        .find('.input__remove')
        .click(function (event) {
            $(this).hide()
            input.val('')
            input.change()
            event.stopPropagation()
            return false
        })
    input
        .change(function () {
            const fieldPreview = parent.find('.input__preview')
            const fieldName = parent.find('.input__label')
            const fieldRemove = parent.find('.input__remove')
            let iconSize = 24;
            if (data.type == 'imagePicker') iconSize = 64;
            if (data.type == 'iconPicker') iconSize = 64;

            if (parseInt(input.val()) > 0) {
                if (data.type == 'docPicker') {
                    ajaxForm({
                        // url: 'api/admin/link/' + input.val(),
                        url: 'api/documents/fichier/' + input.val() + '/',
                        method: 'GET',
                        messages: false,
                        callback(data, form) {
                            fieldPreview.replaceWith(
                                iconImg(
                                    data.data.url,
                                    'input__preview',
                                    null,
                                    'auto',
                                    iconSize
                                )
                            )
                            fieldName.text(data.data.name)
                            fieldRemove.show()
                        },
                    })
                } else if (data.type == 'dataPicker') {
                    ajaxForm({
                        url: 'api/admin/link/' + input.val() + '/',
                        method: 'GET',
                        messages: false,
                        callback(data, form) {
                            fieldPreview.replaceWith(
                                iconImg(
                                    data.data.url_th,
                                    'input__preview',
                                    null,
                                    'auto',
                                    iconSize
                                )
                            )
                            fieldName.text(data.data.name)
                            fieldRemove.show()
                        },
                    })
                } else {
                    ajaxForm({
                        url: 'api/galeries/image/' + input.val() + '/',
                        method: 'GET',
                        messages: false,
                        callback(data, form) {
                            fieldPreview.replaceWith(
                                iconImg(
                                    data.data.url_th,
                                    'input__preview',
                                    null,
                                    'auto',
                                    iconSize
                                )
                            )
                            fieldName.text(data.data.name)
                            fieldRemove.show()
                        },
                    })
                }
            } else {
                fieldPreview.replaceWith(
                    iconImg(
                        (input.val()) ? input.val() : data.icon,
                        'input__preview',
                        null,
                        'auto',
                        iconSize
                    )
                )
                fieldName.text((input.val()) ? input.val() : data.placeholder)
                input.parent().find('.input__remove').hide();
            }
        })
        .change()
    return data
}
